module.exports = __webpack_public_path__ + "static/media/03-11-02.aab60ca0.png";